import React from 'react';
import { Globe, Plus, ArrowRight, LayoutDashboard, Sparkles, AlertCircle } from 'lucide-react';

interface EmptySiteNoticeProps {
  title?: string;
  description?: string;
  onOpenCreateSite?: () => void;
  onReturnToDashboard?: () => void;
}

export const EmptySiteNotice: React.FC<EmptySiteNoticeProps> = ({
  title = 'Aktif Web Sitesi Bulunamadı',
  description = 'Bu yönetim modülünü kullanabilmek için lütfen önce bir web sitesi oluşturun veya mevcut sitelerinizden birini aktif yapın.',
  onOpenCreateSite,
  onReturnToDashboard,
}) => {
  return (
    <div className="p-6 md:p-10 max-w-4xl mx-auto flex flex-col items-center justify-center min-h-[50vh] text-center">
      <div className="w-16 h-16 rounded-3xl bg-blue-500/10 border border-blue-500/20 text-blue-500 flex items-center justify-center mb-6 shadow-md shadow-blue-500/10">
        <Globe className="w-8 h-8" />
      </div>

      <h2 className="text-2xl font-bold text-slate-900 mb-2">{title}</h2>
      <p className="text-slate-600 max-w-lg mb-8 text-sm leading-relaxed">
        {description}
      </p>

      <div className="flex flex-wrap items-center justify-center gap-4">
        {onOpenCreateSite && (
          <button
            onClick={onOpenCreateSite}
            className="px-6 py-3 rounded-xl bg-blue-600 hover:bg-blue-500 text-white font-semibold text-sm shadow-md shadow-blue-600/20 transition flex items-center gap-2"
          >
            <Plus className="w-4 h-4" />
            <span>Yeni Web Sitesi Oluştur</span>
            <Sparkles className="w-4 h-4 text-amber-300" />
          </button>
        )}

        {onReturnToDashboard && (
          <button
            onClick={onReturnToDashboard}
            className="px-6 py-3 rounded-xl bg-white hover:bg-slate-50 border border-slate-300 text-slate-700 font-semibold text-sm transition flex items-center gap-2"
          >
            <LayoutDashboard className="w-4 h-4 text-slate-500" />
            <span>Genel Bakışa Dön</span>
          </button>
        )}
      </div>

      <div className="mt-8 p-4 rounded-2xl bg-amber-50 border border-amber-200 text-amber-900 text-xs max-w-md flex items-start gap-3 text-left">
        <AlertCircle className="w-4 h-4 text-amber-600 shrink-0 mt-0.5" />
        <div>
          <span className="font-semibold block mb-0.5">3 Günlük Ücretsiz Deneme</span>
          Yeni hesabınız ile 1 adet web sitesini ücretsiz oluşturup 72 saat boyunca tüm gelişmiş modülleriyle deneyebilirsiniz.
        </div>
      </div>
    </div>
  );
};
